import React from 'react';
import { useSelector } from 'react-redux';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { Select } from 'ui/components';
import * as Fi from 'react-icons/fi';
import cn from 'classnames';
import _ from 'underscore'

const initialState = {
  vendor: null,
};

const TableImport = ({ data, onDelete, onUpdate, onChange }) => {
  const StateForm = useSelector((state) => state?.Form);
  const [
    { vendor },
    setState,
  ] = React.useState(initialState);


  React.useEffect(() => {

    _.each(data, (i) => {
      i.vendor_id = vendor?.id
    })

    onChange(data)
  }, [vendor])

  return (
    <div>
      <div className="bg-white py-md-3 px-3 border rounded-2">
        <div className="row">
          <div className="mb-3">
            <label className="form-label">Pilih Vendor</label>
            <Select.Remote
              placeholder=""
              url="/partner"
              params={{'type': 'vendor'}}
              value={vendor}
              initialValue={vendor?.id}
              row={(d) => {
                return {
                  value: d.id,
                  label: d.name,
                };
              }}
              onSelected={(c) => {
                setState((prevState) => ({
                  ...prevState,
                  vendor: c,
                }));
              }}
            />

            {StateForm?.errors[`datas.0.vendor_id`] ? (
              <div className="invalid-feedback" style={{ display: 'block' }}>
                {StateForm?.errors[`datas.0.vendor_id`]}
              </div>
            ) : null}
          </div>

          <div className="col-12">
            <div className="hr-text hr-text-left text-primary mb-3 mt-md-3 mt-3">
              Daftar Driver
            </div>

            <div className="table-responsive bg-white">
              <table
                width="100%"
                className="table table-hover table-vcenter card-table datatable border"
              >
                <thead className="bg-light">
                  <tr className="th">
                    <td>No</td>
                    <td
                      style={{
                        whiteSpace: 'pre-wrap',
                        width: '25%',
                        textAlign: 'left',
                      }}
                    >
                      Nama
                    </td>
                    <td
                      style={{
                        whiteSpace: 'pre-wrap',
                        width: '15%',
                        textAlign: 'left',
                      }}
                    >
                      No. Handphone
                    </td>
                    <td
                      style={{
                        whiteSpace: 'pre-wrap',
                        width: '15%',
                        textAlign: 'left',
                      }}
                    >
                      No. Polisi
                    </td>
                    <td
                      style={{
                        whiteSpace: 'pre-wrap',
                        width: '15%',
                        textAlign: 'left',
                      }}
                    >
                      Akun Bank
                    </td>
                    <td></td>
                  </tr>
                </thead>

                <tbody>
                  {data?.map((d, i) => (
                    <tr
                      key={i}
                      className={cn(
                          StateForm?.errors[`datas.${i}.name`] ||
                          StateForm?.errors[`datas.${i}.phone`] ||
                          StateForm?.errors[`datas.${i}.vehicle_number`] ||
                          StateForm?.errors[`datas.${i}.bank_account`]
                          ? 'border-danger border-bottom'
                          : null
                      )}
                    >
                      <td>
                        <div className="text-left fs-8 text-uppercase fw-semibold">
                          {i + 1}
                        </div>
                      </td>
                      <td style={{ whiteSpace: 'nowrap', width: '15%' }}>
                        <div className="text-left fs-8 text-uppercase fw-semibold">
                          {d?.name}
                        </div>
                        {StateForm?.errors[`datas.${i}.name`] ? (
                          <div className="invalid-feedback d-block ">
                            {StateForm?.errors[`datas.${i}.name`]}
                          </div>
                        ) : null}
                      </td>
                      <td style={{ whiteSpace: 'nowrap', width: '15%' }}>
                        <div className="text-left fs-8 text-uppercase fw-semibold">
                          {d?.phone}
                        </div>
                        {StateForm?.errors[`datas.${i}.phone`] ? (
                          <div className="invalid-feedback d-block ">
                            {StateForm?.errors[`datas.${i}.phone`]}
                          </div>
                        ) : null}
                      </td>
                      <td style={{ whiteSpace: 'nowrap', width: '15%' }}>
                        <div className="text-left fs-8 text-uppercase fw-semibold">
                          {d?.vehicle_number}
                        </div>
                        {StateForm?.errors[`datas.${i}.vehicle_number`] ? (
                          <div className="invalid-feedback d-block ">
                            {StateForm?.errors[`datas.${i}.vehicle_number`]}
                          </div>
                        ) : null}
                      </td>
                      <td style={{ whiteSpace: 'nowrap', width: '15%' }}>
                        <div className="text-left fs-8 text-uppercase fw-semibold">
                          {d?.bank_account}
                        </div>
                        {StateForm?.errors[`datas.${i}.bank_account`] ? (
                          <div className="invalid-feedback d-block ">
                            {StateForm?.errors[`datas.${i}.bank_account`]}
                          </div>
                        ) : null}
                      </td>

                      <td className="text-end">
                        <div
                          className="btn-toolbar justify-content-end"
                          role="toolbar"
                        >
                          <div className="btn-group" role="group">
                            <OverlayTrigger
                              placement="bottom"
                              overlay={
                                <Tooltip id={`tooltip-top`}>Perbaharui</Tooltip>
                              }
                            >
                              <button
                                type="button"
                                onClick={() => onUpdate(d, i)}
                                className="btn btn-ghost-primary px-2"
                              >
                                <Fi.FiEdit size={17} />
                              </button>
                            </OverlayTrigger>

                            <OverlayTrigger
                              placement="bottom"
                              overlay={
                                <Tooltip id={`tooltip-top`}>Hapus</Tooltip>
                              }
                            >
                              <button
                                type="button"
                                onClick={() => onDelete(i)}
                                className="btn btn-ghost-danger px-2"
                              >
                                <Fi.FiTrash2 size={17} />
                              </button>
                            </OverlayTrigger>
                          </div>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TableImport;
